module.exports = __webpack_public_path__ + "img/comment.0e45bf0b.svg";